import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Header, Nav, HamburgerMenu, BtnEdit, BtnDelete } from './components'

import { 
    loginUserCheck, 
    logoutUser,
    promotionFetch,
    promotionDeleteById
} from '../redux/actions'

class AdminPromotion extends Component {

    constructor(){
        super()
        this.state = {
            photo: "",
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
        this.props.promotionFetch()
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _handleLogout() {
        this.props.logoutUser()
    }

    _onHandleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    _onDeleteItem(id, files) {
        if(window.confirm('Are you sure you want to delete this item?')) {
            files.oldThumbnail = decodeURIComponent(files.oldThumbnail.substring(70,99))
            files.oldPhoto = decodeURIComponent(files.oldPhoto.substring(70,99))
            this.props.promotionDeleteById(id, files)
        }
    }

    showPromotions() {
        if(this.props.promotions) {
            return this.props.promotions.map((item, index) => {
                let d = new Date(item.promo_id)
                const date = d.getDate()+"/"+(d.getMonth()+1)+"/"+d.getFullYear()
                const search = "?id="+item.id+"&thumbnail="+item.thumbnail+"&photo="+item.photo+
                                "&title="+item.title+"&desc="+item.desc+"&sub_desc="+item.sub_desc
                return (
                    <tr key={++index}>
                        <td>{index}</td>
                        <td className="product-photo">
                            <img src={item.thumbnail} alt="product" />
                        </td>
                        <td>{item.title}</td>
                        <td>{item.sub_desc}</td>
                        <td>{date}</td>
                        <td>{item.created_by}</td>
                        <td>
                            <BtnEdit href="/admin/editpromotion" search={search}/>
                        </td>
                        <td>
                            <BtnDelete click={() => this._onDeleteItem(item.id, { oldThumbnail: item.thumbnail, oldPhoto: item.photo })}/>
                        </td>
                    </tr>
                )
            })
        }
    }

    render() {
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-promotion">
                    <Nav active="promotion"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>โปรโมชั่น</h2>
                                <div className="btn-addpromotion">
                                    <Link to="/admin/addpromotion" className="add-promotion">เพิ่มโปรโมชั่น</Link>
                                </div>
                            </div>
                            <div className="info">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Photo</th>
                                            <th>Title</th>
                                            <th>Sub Description</th>
                                            <th>Created Date</th>
                                            <th>Created By</th>
                                            <th>Edit Promotion</th>
                                            <th>Delete Promotion</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.showPromotions()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, promotion }) => {
    return { 
        user: auth.user,
        promotions: promotion.promotions
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, promotionFetch, promotionDeleteById
})(AdminPromotion)